import { createElement as h } from 'react'
import { render } from 'react-dom'
import { IS_DEV } from './environment'
import { AppModule } from './app/app.module'
import './index.scss'

const boot = () => {
  if (IS_DEV) {
    document.body.classList.add('dev-mode') // DEV MODE Visual cue
  }
  render(h(AppModule), document.getElementById('root'))
}

boot()

if (IS_DEV && module.hot) {
  module.hot.accept('./app/app.module', () => {
    // tslint:disable-next-line:no-console
    console.info('🔁  HMR Reloading `./app/app.module.tsx`...')
    boot()
  })
}



// WEBPACK FOOTER //
// ./src/main.ts